<template>
    <b-modal ref="profile_modal"
             size="xl2"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=false
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close_modal }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">

					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show">
                <div class="panel-content">
                    <b-overlay :show="is_load" rounded="sm">
                        <parts_items :exist_parts="parts_exist" :parts_field=parts_field></parts_items>
                    </b-overlay>
                </div>
            </div>
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
                
                <button type="button" v-on:click="save_parts" class="btn btn-primary waves-effect waves-themed">
                    Зберегти
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>



import parts_items from "../../../../../create/mem_preview/addon/parts/adv/parts_items.vue";

export default {
    name: "parts_edit_items",
    components: {
        parts_items,
        
    },
    created() {
        EventBus.$on('edit_parts',this.check_rights);
    },
    
    props: {
        doc_id: {
            type: String | Number,
            required: true
        },
    },
    
    data() {
        return {
            is_load: false,
            is_show_modal: false,
            parts_field: {
                insert_val : []
            },
            parts_exist : [],
        }
    },
    
    methods : {
        show_modal() {
            this.is_show_modal = true;
            this.parts_exist = [];
            this.parts_field.insert_val = [];
            
        },
        
        close() {
            this.is_show_modal = false;
            this.parts_field.insert_val = [];
            this.parts_exist = [];
        },
        
        async load_parts() {
            this.parts_exist = [];
            
            await api.get('/memorandums/' +this.doc_id).then(({data}) => {
                if (data.status === "operation_success") {
                    
                    let memorandum = data.data;
                    let fields_parts = memorandum.addon_data;
                    
                    if(fields_parts.hasOwnProperty('parts')) {
                        fields_parts.parts.map(part => {
                            this.parts_exist.push(part);
                        });
                    }
                }
            }).catch(err => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async check_rights() {
            
            IMC_CORE.showloading();
            await api.get('/memorandums/' +this.doc_id + '/rights').then(({data}) => {
                if (data.status === "operation_success") {
                    let res = data.data;
                    IMC_CORE.hideloading();
                    
                    if (res.hasOwnProperty("rights")) {
                        let rights = res.rights;
                        if (rights === 'active' || rights === 'draft_init' || rights === 'active vip_user' || rights === 'init_user_restart') {
                            this.show_modal();
                            this.load_parts();
                        }
                    }else {
                        EventBus.$emit('show_toast', {
                            err: 'Не можливо редагувати!',
                            type: "danger",
                            title: 'Редагування заблоковано'
                        })
                    }
                }
            }).catch(err => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async save_parts() {
            IMC_CORE.showloading();
            await api.patch('/memorandums/' +this.doc_id + '/parts/items', {
                    'parts'         : this.parts_field,
                    'exist_parts'   : this.exist_parts
                }
            ).then(({data}) => {
                if (data.status === "operation_success") {
                    IMC_CORE.hideloading();
                    window.location.reload();
                }
            }).catch(err => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
    },
    
    computed: {
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-center modal-lg";
            }
            
            return "modal-dialog-center modal-lg";
        },
    }
}
</script>

<style scoped>

</style>
